import { render, staticRenderFns } from "./TextractResult.vue?vue&type=template&id=1d9c9192&"
import script from "./TextractResult.vue?vue&type=script&lang=js&"
export * from "./TextractResult.vue?vue&type=script&lang=js&"
import style0 from "./TextractResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports